import React from 'react';
import I18n from 'i18n-js';
import { ChildProps } from '@apollo/client/react/hoc';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { IUserContext, withUserContext } from '@reverbdotcom/commons';
import { userContextIsTrackable } from '@reverbdotcom/commons/src/elog/mparticle';
import { RECENTLY_VIEWED_LISTINGS_QUERY } from '@reverbdotcom/commons/src/cms/components/recently_viewed_listings';
import { CommonsCmsRecentlyViewedListings } from '@reverbdotcom/commons/src/gql/graphql';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import CPRecommendationsListingsRow from '../../recommended_listings/cp_recommendations_listings_row';

const DEFAULT_LISTINGS_COUNT = 6;
const RECS_LIMIT = 16;
export type IProps = ChildProps<IUserContext, CommonsCmsRecentlyViewedListings.Query, CommonsCmsRecentlyViewedListings.Variables>;

export function BasedOnRecentlyViewed(props: IProps) {
  return (
    <CPRecommendationsListingsRow
      title={I18n.t('discovery.homepage.basedOnRecentlyViewed')}
      listingsLimit={DEFAULT_LISTINGS_COUNT}
      recsLimit={RECS_LIMIT}
      recommendedFrom={props?.data?.recentlyViewedListings || []}
      componentName="BasedOnRecentlyViewed"
      displayAsGridOnMobile
    />
  );
}

const connect = withGraphql<IProps, CommonsCmsRecentlyViewedListings.Query, CommonsCmsRecentlyViewedListings.Variables>(
  RECENTLY_VIEWED_LISTINGS_QUERY,
  {
    options: ownProps => ({
      ssr: false,
      variables: {
        limit: DEFAULT_LISTINGS_COUNT,
        showListingLocation: isExperimentEnabled(ownProps.user, experiments.LISTING_CARD_LOCATION),
        shouldSkipTracking: !userContextIsTrackable(ownProps.user),
      },
    }),
  },
);

export default withUserContext<IProps>(connect(BasedOnRecentlyViewed));
